import { trackSearchResultsFacetClickEvent } from '@sitecore-search/data';
import { getSearchEventData } from '../../../../utils/events.js';
import ChangeItemBuilder from '../ChangeItemBuilder.js';
import FacetChangedActionHandler from './FacetChangedActionHandler.js';
export default class ChoiceChangedActionHandler extends FacetChangedActionHandler {
    process(rfkId, query, payload) {
        const { facetId, facetValueId, facetIndex, facetValueIndex: valueIndex, silentTracking, checked, } = payload;
        const { facetValues, facetTitle } = this.getCurrentFacetInfo(query, payload);
        const facetValue = facetValues.find(({ id }) => id === facetValueId)?.text || '';
        if (!silentTracking) {
            trackSearchResultsFacetClickEvent(rfkId, query.getRequest().getEntity(), {
                filters: [
                    {
                        facetId,
                        facetValueId,
                        facetValue,
                        valueIndex,
                        facetIndex,
                        facetTitle,
                    },
                ],
                ...getSearchEventData(query),
            });
        }
        query.getRequest().setSearchOffset(0);
        if (checked) {
            query.getRequest().addSearchFacetTypeFilter(facetId, ChangeItemBuilder.buildItem(query, payload));
        }
        else {
            query.getRequest().removeSearchFacetTypeFilter(facetId, ChangeItemBuilder.buildItem(query, payload));
        }
    }
}
